import { useContext, useEffect } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { GlobalContext } from '../../library/Core/GlobalContext';
import { DispatchEvent, State } from '../../library/Core/SmartTypes';
import smartReducer from '../../library/Core/SmartReducer';
// import { addUserSpecificDomains } from '../../library/Service/domainService';
import { SmartContext } from '../../library/Core/SmartContext';
import TopCareerLayout from './TopCareerLayout';
import PageBuilder from '../../library/Builders/PageBuilder/PageBuilder';
import DebugBarControl from '../../library/SimpleControls/DebugBarControl';

const TopCareer = () => {
    const { globalState } = useContext(GlobalContext);
    const { id, pageName } = useParams();
    const navigate = useNavigate();

    
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {},
    } as any);

    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    // console.log('data in main component');
    // console.log(data);
    useEffect(() => {
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain: new Map([...globalState.domain]), internal, routeInfo },
        });
    }, [data]);

    // const StudenttestMenu = JSON.parse(sessionStorage.getItem('product-menu-test') || '{}');
    const StudenttestMenu = JSON.parse(localStorage.getItem('product-menu-test') || '{}');
    const allowAccess = StudenttestMenu && Object.keys(StudenttestMenu).length > 0 
            && StudenttestMenu.career_deep_dive === true;

    if (!allowAccess) {
        return (
            <main className='flex-1'>
                <div className="mx-auto max-420 my-5 text-center">
                    <div className="access-denied-card">
                        <FontAwesomeIcon icon={faLock} className="access-denied-icon font-48 text-danger mb-3" />
                        <h2 className='font-26 font-500 mb-1'>Access Denied</h2>
                        <p className='font-18 mb-2'>You do not have permission to access this page.</p>
                        <p className='font-18 mb-4'>Please contact support for more information.</p>
                        <button className="btn-border-gray" onClick={() => navigate(-1)}>
                            <span>
                                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                                Go Back
                            </span>
                        </button>
                    </div>
                </div>
            </main>
        );
    }

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <DebugBarControl />
            {!state.flags.isDataLoading && <TopCareerLayout>{!state.flags.isDataLoading && <PageBuilder />}</TopCareerLayout>}
        </SmartContext.Provider>
    );
};

export default TopCareer;
